import { render } from "./BaseTabsHandler.vue?vue&type=template&id=5ce7d1f8&scoped=true"
import script from "./BaseTabsHandler.vue?vue&type=script&lang=js"
export * from "./BaseTabsHandler.vue?vue&type=script&lang=js"

import "./BaseTabsHandler.vue?vue&type=style&index=0&id=5ce7d1f8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce7d1f8"]])

export default __exports__